import React from 'react'
import { CardHeader, Heading, Flex, Image } from 'vvs-uikit'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'

const Wrapper = styled(CardHeader)`
  background: linear-gradient(89.96deg, #3acecd 50.12%, #5557f4 99.83%);
  border-radius: ${({ theme }) => `${theme.radii.card} ${theme.radii.card} 0 0`};
  padding: 12px 24px;
`

const MyEarningsCardHeader: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Flex alignItems="center" justifyContent="space-between">
        <Image alt="vault icon" src="/images/xVVS/xvvs-vault-icon.png" width={64} height={56} mt={2} />
        <Heading scale="md" color="white">
          {t('My Earnings')}
        </Heading>
      </Flex>
    </Wrapper>
  )
}

export default MyEarningsCardHeader
